import * as React from "react";
import { toINR } from "../../../../service/numberFormat";
import { marginIntraFnoHeading } from "../../marginConstants";
import { ISortProps } from "../../../../types/components/margin/marginTypes";
import MarginSort from "../../generic/marginSort";
import { marginScrollService } from "../../../../service/marginFiles/marginScrollService";

export interface IMarginIntraFnoTableMobProps {
	tableData: Array<any>;
	filteredData: Array<any>;
	numOfRows: number;
	sortProps: ISortProps;
	setTableData: (tableData: Array<any>) => void;
}

const MarginIntraFnoTableMob: React.FC<IMarginIntraFnoTableMobProps> = props => {
	const scrollBodyRef = React.useRef<HTMLUListElement>(null);
	const fixedBodyRef = React.useRef<HTMLUListElement>(null);
	const scrollHeadRef = React.useRef<HTMLUListElement>(null);

	return (
		<div className="mrgn_ifno_tbl margin_table_mob">
			<div className="fixed_col">
				<ul className="hdr_row">
					<li className="tr">
						<div className="td">
							<span className="sort_cont ScripName">
								<MarginSort
									sortList={props.filteredData}
									sortedColName={props.sortProps.sortedColumnState.colName}
									sortKey="ScripName"
									onSort={props.sortProps.onSort}
									colName={marginIntraFnoHeading.scripName}
								/>
							</span>
						</div>
					</li>
				</ul>
				<ul className="data_rows" ref={fixedBodyRef}>
					{props.tableData.slice(0, props.numOfRows).map((row, index) => (
						<li className="tr" key={index}>
							<div className="td">
								<span className="ScripName ib" dangerouslySetInnerHTML={{ __html: row.ScripName }}></span>
							</div>
						</li>
					))}
				</ul>
			</div>

			<div className="scrolling_cont">
				<ul className="hdr_row" ref={scrollHeadRef}>
					<li className="tr">
						<div className="td">
							<span className="sort_cont Marketlot">
								<MarginSort
									sortList={props.filteredData}
									sortedColName={props.sortProps.sortedColumnState.colName}
									sortKey="Marketlot"
									onSort={props.sortProps.onSort}
									colName={marginIntraFnoHeading.marketlot}
								/>
							</span>
						</div>
						<div className="td">
							<span className="sort_cont TotalMarginLongPos">
								<MarginSort
									sortList={props.filteredData}
									sortedColName={props.sortProps.sortedColumnState.colName}
									sortKey="TotalMarginLongPos"
									onSort={props.sortProps.onSort}
									colName={marginIntraFnoHeading.totalMarginLongPos}
								/>
							</span>
						</div>
						<div className="td">
							<span className="sort_cont TotalMarginPerLot">
								<MarginSort
									sortList={props.filteredData}
									sortedColName={props.sortProps.sortedColumnState.colName}
									sortKey="TotalMarginPerLot"
									onSort={props.sortProps.onSort}
									colName={marginIntraFnoHeading.totalMarginPerLot}
								/>
							</span>
						</div>
						<div className="td">
							<span className="sort_cont MISMargin">
								<MarginSort
									sortList={props.filteredData}
									sortedColName={props.sortProps.sortedColumnState.colName}
									sortKey="MISMargin"
									onSort={props.sortProps.onSort}
									colName={marginIntraFnoHeading.misMargin}
								/>
							</span>
						</div>
						<div className="td">
							<span className="sort_cont MISMarginperLot">
								<MarginSort
									sortList={props.filteredData}
									sortedColName={props.sortProps.sortedColumnState.colName}
									sortKey="MISMarginperLot"
									onSort={props.sortProps.onSort}
									colName={marginIntraFnoHeading.misMarginperLot}
								/>
							</span>
						</div>
					</li>
				</ul>
				<ul className="data_rows" ref={scrollBodyRef} onScroll={() => marginScrollService(scrollBodyRef, fixedBodyRef, scrollHeadRef)}>
					{props.tableData.slice(0, props.numOfRows).map((row, index) => (
						<li className="tr" key={index}>
							<div className="td">
								<span className="Marketlot ib">{row.Marketlot}</span>
							</div>
							<div className="td">
								<span className="TotalMarginLongPos ib">{row.TotalMarginLongPos}</span>
							</div>
							<div className="td">
								<span className="TotalMarginPerLot ib">{toINR(row.TotalMarginPerLot)}</span>
							</div>
							<div className="td">
								<span className="MISMargin ib">{toINR(row.MISMargin)}</span>
							</div>
							<div className="td">
								<span className="MISMarginperLot ib">{toINR(row.MISMarginperLot)}</span>
							</div>
						</li>
					))}
				</ul>
			</div>
		</div>
	);
};

export default MarginIntraFnoTableMob;
